import React, { useContext, useEffect, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux';
// import { addOnView, addWebSiteDetails } from '../../Redux/Actions/CardAction'
// import { CardContext } from "../../store/CardContext";

const Forms = () => {
  // const { websiteDetails, websiteImage } = useSelector((state) => state.cardReducer);
  const urlRegex = /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
  // const initialValues = {
  //   websiteName: websiteDetails?.websiteName, websiteUrl: websiteDetails?.websiteUrl
  // }
  // const dispatch = useDispatch();
  const [websiteDetail, setWebsiteDetails] = useState('')
  // const [userContextData, setUserContextData] = useContext(CardContext)

  // useEffect(()=>{
  //   setWebsiteDetails({
  //     websiteName: userContextData?.websiteName,
  //      websiteUrl: userContextData?.websiteUrl
  //   })
  // },[userContextData])
  const [websiteDetails]=useState('')
  const [websiteImage]=useState([])


  const handleChange = (e) => {
    const { name, value } = e.target
    setWebsiteDetails({ ...websiteDetail, [name]: value })

  }

  useEffect(() => {
    // dispatch(addWebSiteDetails(websiteDetail));
    // dispatch(addOnView("websiteDetail"));
  }, [websiteDetail]);

  return (
    <div className="grid gap-6 mb-6 md:grid-cols-2">
      <div>
        <label for="first_name" className="block mb-2 text-sm font-medium text-gray-900">Name</label>
        <input type="text" name="Name.." className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 " placeholder="" onChange={handleChange} value={websiteDetails?.websiteName || ""} />
        {((websiteImage[0]?.thumbUrl &&
          websiteImage[0]?.status !== "removed") || websiteDetail?.websiteUrl) && !websiteDetail?.websiteName ? (
          <p className="text-red-500">website Name is required</p>
        ) : (
          ""
        )}
      </div>
      <div>
        <label for="first_name" className="block mb-2 text-sm font-medium text-gray-900 ">Description</label>
        <input type="text" name="Description.." className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 " placeholder="" onChange={handleChange} value={websiteDetails?.websiteUrl || ""} />
        {((websiteImage[0]?.thumbUrl &&
          websiteImage[0]?.status !== "removed") || websiteDetail?.websiteName) && !websiteDetail?.websiteUrl ? (
          <p className="text-red-500">website Url is required</p>
        ) : (

          '')}

        {websiteDetail?.websiteUrl ? (urlRegex.test(websiteDetail.websiteUrl)) ?
          ""
          : (
            <p className="text-red-500">Enter Valid Website Url</p>
          ) : ""}

      </div>
    </div>

  )
}

export default Forms


